<script setup>
import CheckoutSection from '#common/components/Checkout/CheckoutSection.vue'
import DateFormattedTextFieldFK from '#common/components/DateFormattedTextFieldFK.vue'
defineProps({
  id: {
    type: String,
    required: true,
  },
})
const emit = defineEmits(['commit'])
const errors = ref([])
const formValues = ref({})
const memberships = useMemberships()
const sectionState = computed(() => memberships.sectionState)
const drawerOpen = computed(() => {
  return sectionState.value.contactInformation.drawerOpen
})
const committedName = computed(() => {
  return `${sectionState.value.contactInformation.firstName} ${sectionState.value.contactInformation.lastName}`
})
const committedEmail = computed(() => {
  return sectionState.value.contactInformation.email
})
const commitedDOB = computed(() => {
  return moment(
    sectionState.value.contactInformation.gifter_date_of_birth,
    'YYYY-MM-DD',
  ).format('MM/DD/YYYY')
})
const sectionClasses = computed(() => {
  const classes = ['checkout-details-section']
  if (!drawerOpen.value) {
    classes.push('edit-section')
  }
  return classes
})
onMounted(() => {
  formValues.value.firstName = sectionState.value.contactInformation.firstName
  formValues.value.lastName = sectionState.value.contactInformation.lastName
  formValues.value.email = sectionState.value.contactInformation.email
  formValues.value.dob =
    sectionState.value.contactInformation.gifter_date_of_birth
})

function commit() {
  memberships.setSectionState({
    section: 'contactInformation',
    value: {
      drawerOpen: false,
      firstName: formValues.value.firstName,
      lastName: formValues.value.lastName,
      email: formValues.value.email,
      gifter_date_of_birth: formValues.value.dob,
    },
  })
  emit('commit')
}
function openDrawer() {
  memberships.setSectionDrawerOpen({
    section: 'contactInformation',
    value: true,
  })
}
function closeDrawer() {
  errors.value = []
  memberships.setSectionDrawerOpen({
    section: 'contactInformation',
    value: false,
  })
}
</script>

<template>
  <CheckoutSection
    :id="id"
    section-title="Your Contact Information"
    :show-section-number="true"
    :section-number="2"
    :enabled="true"
    :drawer-open="drawerOpen"
    :show-change-link="true"
    :errors="errors"
    change-text="Edit"
    :classes="sectionClasses"
    @drawerOpen="openDrawer"
    @drawerClosed="closeDrawer"
  >
    <template #collapsed>
      <div class="checkout-section-summary">
        <ul>
          <li>{{ committedName }}</li>
          <li>{{ committedEmail }}</li>
          <li>{{ commitedDOB }}</li>
        </ul>
      </div>
    </template>
    <template #expanded>
      <div class="checkout-section-content">
        <FormKit
          id="contact-information"
          v-model="formValues"
          type="form"
          :actions="false"
          name="contact-information"
          class="checkout-form"
          @submit="commit"
        >
          <div class="row">
            <div class="columns medium-6">
              <div class="floating">
                <FloatingInputFK
                  id="input-buyer-firstname"
                  name="firstName"
                  validation="required"
                  placeholder="First Name"
                  label="First Name"
                />
              </div>
            </div>
            <div class="columns medium-6">
              <div class="floating">
                <FloatingInputFK
                  id="input-buyer-lastname"
                  name="lastName"
                  validation="required"
                  placeholder="Last Name"
                  label="Last Name"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="columns medium-6 label-fix">
              <div class="floating">
                <FloatingInputFK
                  id="input-buyer-email"
                  name="email"
                  validation="bail|required|email"
                  placeholder="Email Address"
                  label="Email Address"
                />
              </div>
            </div>

            <div class="columns medium-6">
              <div class="floating">
                <DateFormattedTextFieldFK
                  id="input-dob"
                  name="dob"
                  label="Date of Birth (To verify you're over 21)"
                  input-class="static__input"
                  date-placeholder="MM/DD/YYYY"
                  validation="bail|required|date:YYYY-MM-DD|livingBirthday|legalBirthday"
                  :max="moment().format('YYYY-MM-DD')"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="columns small-12 medium-9 large-6">
              <button
                type="submit"
                form="contact-information"
                class="primary btn-continue left"
              >
                Continue
              </button>
            </div>
          </div>
        </FormKit>
      </div>
    </template>
  </CheckoutSection>
</template>
